import React, {memo} from 'react';
import clsx from 'clsx';

import {REACTION_ICON_SIZES, REACTION_NAMES} from '../constants';

import ReactionIcon from './reaction-icon';

import styles from '../reactions.module.css';

const Reaction = memo(({
  type,
  count = '',
  size = REACTION_ICON_SIZES.MEDIUM,
  withCount = false,
  withTitle = false,
  isActive = false,
  onClick = () => null
}) => {
  const reactionName = REACTION_NAMES[type][window.Site.targeting.section];

  return (
    <div
      onClick={() => onClick(type)}
      className={clsx(
        styles.reaction,
        {
          [styles.withTitle]: withTitle,
          [styles.withCount]: !!count,
          [styles.isActive]: isActive
        })}
    >
      <ReactionIcon type={type} size={size} />
      {withCount ? <span className={styles.reactionCount}>{count}</span> : null}
      {withTitle ? <p className={styles.reactionTitle}>{reactionName}</p> : null}
    </div>
  );
});

export default Reaction;
